import { default as Skeleton } from '@mui/material/Skeleton';

export const AssignmentDetailsSkeleton = () => (
  <Skeleton data-testid="assignment-details-skeleton" height={160} />
);
